<nz-card *ngIf="!this.loaders['isFormLoading'].loading; else showLoader" class="relative">
    <ng-container *ngIf="tabs && tabs.length > 0 ; else noTabs">
            <nz-tabset [(nzSelectedIndex)]="currentTab" [nzTabBarExtraContent]="extraContent" nzSize="small">
                <ng-container *ngFor="let tab of tabs; trackBy: feUtil.trackByFn">
                    <nz-tab [nzTitle]="tab?.form_name || ''" [nzDisabled]="tab.disabled">
                        <div [ngClass]="{
                                            'min-h-[360px] h-[360px] max-h-[360px] pb-2': tab.tab_type === 'history',
                                            'min-h-[290px] max-h-[290px]': tab.tab_type !== 'history' && (tab.form_type !== 'capa')}"
                            class="overflow-y-auto no-scrollbar overflow-x-hidden">
                            <ng-container *ngIf="tab.tab_type === 'form'">
                                <div>
                                    @if (getFormGroup(tab?.form_type)) {
                                    <form nz-form nzLayout="vertical" [formGroup]="getFormGroup(tab?.form_type)!">
                                        <nz-row [nzGutter]="[8,0]">
                                            <ng-container *ngIf="tab.form_type === 'prod'">
                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="8">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                            <nz-form-label
                                                                [nzRequired]="isRequired(tab.form_type, 'isImpacted')">Were
                                                                any
                                                                products impacted?</nz-form-label>
                                                            <nz-select [nzPlaceHolder]="'Select'" formControlName="isImpacted"
                                                                class="w-full">
                                                                <nz-option nzValue="Yes" nzLabel="Yes"></nz-option>
                                                                <nz-option nzValue="No" nzLabel="No"></nz-option>
                                                            </nz-select>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </nz-col>
                                                <ng-container
                                                    *ngIf="getFormGroup(tab?.form_type)!.get('isImpacted')?.value === 'Yes'">
                                                    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="4">
                                                        <button nz-button nzType="default" class="w-full mt-[30px]"
                                                            type="button" (click)="openProductModal()">
                                                            <i nz-icon [nzType]="products.length > 0 ? 'eye' : 'plus'"
                                                                class="mr-1"></i>
                                                            {{ products.length > 0 ? 'View Products' : 'Add Products' }}
                                                        </button>
                                                    </nz-col>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="getFormGroup(tab?.form_type)!.get('isImpacted')?.value === 'Yes'">
                                                    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12">
                                                        <nz-form-item>
                                                            <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                <nz-form-label
                                                                    [nzRequired]="isRequired(tab.form_type, 'shiftedYesNo')">Was
                                                                    the Impacted Product(s) immediately
                                                                    shifted
                                                                    to alternate
                                                                    Area?</nz-form-label>
                                                                <nz-select [nzPlaceHolder]="'Select'"
                                                                    formControlName="shiftedYesNo" class="w-full">
                                                                    <nz-option nzValue="Yes" nzLabel="Yes"></nz-option>
                                                                    <nz-option nzValue="No" nzLabel="No"></nz-option>
                                                                </nz-select>
                                                            </nz-form-control>
                                                        </nz-form-item>
                                                    </nz-col>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="getFormGroup(tab?.form_type)!.get('isImpacted')?.value === 'Yes' && getFormGroup(tab?.form_type)!.get('shiftedYesNo')?.value === 'Yes' && metaData.page === 'tr-incident'">
                                                    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="8">
                                                        <nz-form-item>
                                                            <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                <nz-form-label
                                                                    [nzRequired]="isRequired(tab.form_type, 'shiftedTo')">Shifted
                                                                    to</nz-form-label>
                                                                <nz-select formControlName="shiftedTo" class="w-full"
                                                                    [nzPlaceHolder]="'Select an option'">
                                                                    <nz-option nzValue="Truck" nzLabel="Truck"></nz-option>
                                                                    <nz-option nzValue="Area" nzLabel="Area"></nz-option>
                                                                </nz-select>
                                                            </nz-form-control>
                                                        </nz-form-item>
                                                    </nz-col>
                                                    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="8">
                                                        <nz-form-item>
                                                            <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                <nz-form-label
                                                                    [nzRequired]="isRequired(tab.form_type, 'shiftDatetime')">Date
                                                                    & Time Shifted</nz-form-label>
                                                                <nz-date-picker [nzShowToday]="false" [nzPlaceHolder]="'Select date & time'"
                                                                    [nzDisabledDate]="disabledDate"
                                                                    [nzShowTime]="{ nzFormat: 'HH:mm' }"
                                                                    nzFormat="yyyy-MM-dd HH:mm" formControlName="shiftDatetime"
                                                                    class="w-full">
                                                                </nz-date-picker>
                                                            </nz-form-control>
                                                        </nz-form-item>
                                                    </nz-col>
        
                                                    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12">
                                                        <nz-form-item>
                                                            <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                <nz-form-label
                                                                    [nzRequired]="isRequired(tab.form_type, 'shiftTargetName')">Shifted
                                                                    to detail</nz-form-label>
                                                                <nz-textarea-count [nzMaxCharacterCount]="500">
                                                                    <textarea maxlength="500" rows="4" nz-input
                                                                        placeholder="Enter the details"
                                                                        formControlName="shiftTargetName"
                                                                        class="w-full"></textarea>
                                                                </nz-textarea-count>
                                                            </nz-form-control>
                                                        </nz-form-item>
                                                    </nz-col>
                                                </ng-container>
                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24"
                                                    [nzLg]="getFormGroup(tab?.form_type)!.get('shiftedYesNo')?.value === 'Yes' && metaData.page === 'tr-incident' ? 12 : 24">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                            <nz-form-label
                                                                [nzRequired]="isRequired(tab.form_type, 'immedCorrDetail')">Details</nz-form-label>
                                                            <nz-textarea-count [nzMaxCharacterCount]="500">
                                                                <textarea maxlength="500" rows="4" nz-input
                                                                    placeholder="Enter the details"
                                                                    formControlName="immedCorrDetail" class="w-full"></textarea>
                                                            </nz-textarea-count>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </nz-col>
                                            </ng-container>
        
                                            <ng-container *ngIf="tab.form_type === 'capa'">
                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12">
                                                    <span class="text-sm font-semibold text-primary">Reason for
                                                        Excursion</span>
                                                    <div class="max-h-[350px] overflow-y-auto overflow-x-hidden no-scrollbar">
                                                        <nz-row [nzGutter]="[0, 0]"
                                                            *ngIf="metaData.page === 'tr-incident'">
                                                            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                                <nz-form-item>
                                                                    <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                        <nz-form-label
                                                                            [nzRequired]="isRequired(tab.form_type, 'isVehicleSealed')">Was
                                                                            the vehicle
                                                                            sealed?</nz-form-label>
                                                                        <nz-radio-group formControlName="isVehicleSealed"
                                                                            class="w-full flex gap-2">
                                                                            <label nz-radio nzValue="Yes">Yes</label>
                                                                            <label nz-radio nzValue="No">No</label>
                                                                        </nz-radio-group>
                                                                    </nz-form-control>
                                                                </nz-form-item>
                                                            </nz-col>
                                                            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                                <nz-form-item>
                                                                    <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                        <nz-form-label
                                                                            [nzRequired]="isRequired(tab.form_type, 'isCoolingWorking')">Was
                                                                            the cooling working
                                                                            when vehicle
                                                                            was
                                                                            received
                                                                            and
                                                                            being
                                                                            updated
                                                                            at CFA/HUB ?
                                                                        </nz-form-label>
                                                                        <nz-radio-group formControlName="isCoolingWorking"
                                                                            class="w-full flex gap-2">
                                                                            <label nz-radio nzValue="Yes">Yes</label>
                                                                            <label nz-radio nzValue="No">No</label>
                                                                        </nz-radio-group>
                                                                    </nz-form-control>
                                                                </nz-form-item>
                                                            </nz-col>
                                                            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                                <nz-form-item>
                                                                    <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                        <nz-form-label
                                                                            [nzRequired]="isRequired(tab.form_type, 'isMalfunctionReported')">Discuss
                                                                            with driver
                                                                            to find out if
                                                                            vehicle or
                                                                            cooling unit malfunctioned
                                                                            during transit?</nz-form-label>
                                                                        <nz-radio-group formControlName="isMalfunctionReported"
                                                                            class="w-full flex gap-2">
                                                                            <label nz-radio nzValue="Yes">Yes</label>
                                                                            <label nz-radio nzValue="No">No</label>
                                                                        </nz-radio-group>
                                                                    </nz-form-control>
                                                                </nz-form-item>
                                                            </nz-col>
                                                            <ng-container
                                                                *ngIf="getFormGroup(tab?.form_type)!.get('isMalfunctionReported')?.value === 'Yes'">
                                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                                    <nz-form-item #reasonForExcursionFormItem>
                                                                        <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                            <nz-form-label
                                                                                [nzRequired]="isRequired(tab.form_type, 'reasonForExcursion')">Details</nz-form-label>
                                                                            <nz-textarea-count [nzMaxCharacterCount]="500">
                                                                                <textarea maxlength="500" rows="4" nz-input
                                                                                    placeholder="Enter the details"
                                                                                    formControlName="reasonForExcursion"
                                                                                    class="w-full"></textarea>
                                                                            </nz-textarea-count>
                                                                        </nz-form-control>
                                                                    </nz-form-item>
                                                                </nz-col>
                                                            </ng-container>
                                                        </nz-row>
                                                        <div>
                                                            <nz-row [nzGutter]="[16,0]"
                                                                *ngIf="metaData.page === 'storage-incident'">
                                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12"
                                                                    class="mt-2">
                                                                    <nz-form-item>
                                                                        <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                            <nz-form-label
                                                                                [nzRequired]="isRequired(tab.form_type, 'reasonForExcursion')">Reason
                                                                                for Excursion</nz-form-label>
                                                                            <nz-select
                                                                                [nzPlaceHolder]="'Select reason for excursion'"
                                                                                formControlName="reasonForExcursion"
                                                                                class="w-full">
                                                                                <nz-option
                                                                                    *ngFor="let reason of reasons; trackBy: feUtil.trackByFn"
                                                                                    [nzValue]="reason['reason_of_exceursion']"
                                                                                    [nzLabel]="reason['reason_of_exceursion']"></nz-option>
                                                                            </nz-select>
                                                                        </nz-form-control>
                                                                    </nz-form-item>
                                                                </nz-col>
                                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24"
                                                                    class="mt-2.5">
                                                                    <nz-form-item>
                                                                        <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                            <nz-form-label
                                                                                [nzRequired]="isRequired(tab.form_type, 'details')">Details</nz-form-label>
                                                                            <nz-textarea-count [nzMaxCharacterCount]="500">
                                                                                <textarea maxlength="500" rows="4" nz-input
                                                                                    placeholder="Enter the details"
                                                                                    formControlName="details"
                                                                                    class="w-full"></textarea>
                                                                            </nz-textarea-count>
                                                                        </nz-form-control>
                                                                    </nz-form-item>
                                                                </nz-col>
                                                            </nz-row>
                                                        </div>
                                                    </div>
                                                </nz-col>
                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12"
                                                    class="border-l border-dashed border-gray-200">
                                                    <div class="pl-3">
                                                        <div class="flex items-center justify-between">
                                                            <span class="text-sm font-semibold text-primary">Capa
                                                                Implementation</span>
                                                            <ng-container
                                                                *ngIf="capaFiles.length === 0 && rejectedCapaFiles.length === 0; else viewCapaFiles">
                                                                <button *ngIf="!metaData?.hide_forms" nz-button nzType="text" type="button"
                                                                    (click)="modals['isCapaModalVisible'] = true">
                                                                    <i nz-icon nzType="plus" nzTheme="outline"></i> Add CAPA
                                                                </button>
                                                            </ng-container>
                                                            <ng-template #viewCapaFiles>
                                                                <ng-container
                                                                    *ngIf="actionDetails['capa']['submitted_at'] && capaFiles.length > 0; else showViewCapaFiles">
                                                                    <button nz-button nzType="text"
                                                                        (click)="downloadCapaFiles()">
                                                                        <i nz-icon nzType="download" nzTheme="outline"></i>
                                                                        Download Capa Files
                                                                    </button>
                                                                </ng-container>
                                                                <ng-template #showViewCapaFiles>
                                                                    <button nz-button nzType="text"
                                                                        (click)="modals['isCapaModalVisible'] = true">
                                                                        <i nz-icon nzType="eye" nzTheme="outline"></i>
                                                                        View capa files
                                                                    </button>
                                                                </ng-template>
                                                            </ng-template>
                                                        </div>
                                                        <nz-row [nzGutter]="[8,8]">
                                                            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                                <nz-form-item>
                                                                    <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                        <nz-form-label
                                                                            [nzRequired]="isRequired(tab.form_type, 'capaImpDate')">Capa
                                                                            Implementation
                                                                            Date</nz-form-label>
                                                                        <nz-date-picker [nzShowToday]="false" [nzDisabledDate]="disabledDate"
                                                                            [nzPlaceHolder]="'Select implementation date'"
                                                                            [nzShowTime]="false" nzFormat="yyyy-MM-dd"
                                                                            formControlName="capaImpDate" class="w-full">
                                                                        </nz-date-picker>
                                                                    </nz-form-control>
                                                                </nz-form-item>
                                                            </nz-col>
                                                            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                                <nz-form-item>
                                                                    <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                                        <nz-form-label
                                                                            [nzRequired]="isRequired(tab.form_type, metaData.page === 'tr-incident' ? 'details' : 'comment')">Details</nz-form-label>
                                                                        <nz-textarea-count [nzMaxCharacterCount]="500">
                                                                            <textarea maxlength="500" rows="4" nz-input
                                                                                placeholder="Enter the details"
                                                                                [formControlName]="metaData.page === 'tr-incident' ? 'details' : 'comment'"
                                                                                class="w-full"></textarea>
                                                                        </nz-textarea-count>
                                                                    </nz-form-control>
                                                                </nz-form-item>
                                                            </nz-col>
                                                        </nz-row>
                                                    </div>
                                                </nz-col>
                                            </ng-container>
        
                                            <ng-container *ngIf="tab.form_type === 'eval'">
                                                <ng-container>
                                                    <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="8">
                                                        <nz-form-item>
                                                            <nz-form-label
                                                                [nzRequired]="isRequired(tab.form_type, 'productDisposition')">Product
                                                                Disposition</nz-form-label>
                                                            <nz-form-control>
                                                                <div style="display: flex; gap: 8px;">
                                                                    <button nz-button nzType="primary" type="button"
                                                                        style="width: 45%;" (click)="openProductModal()"
                                                                        *ngIf="getFormGroup('prod')!.get('isImpacted')?.value === 'Yes'">
                                                                        Check Products
                                                                    </button>
                                                                    <input type="text" nz-input style="width: 55%;"
                                                                        formControlName="productDisposition" />
                                                                </div>
                                                            </nz-form-control>
                                                        </nz-form-item>
                                                    </nz-col>
                                                </ng-container>
                                                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="24">
                                                    <nz-form-item>
                                                        <nz-form-control [nzErrorTip]="errorMessageTemplate">
                                                            <nz-form-label
                                                                [nzRequired]="isRequired(tab.form_type, 'impactAssessment')">Impact
                                                                Assessment</nz-form-label>
                                                            <nz-textarea-count [nzMaxCharacterCount]="500">
                                                                <textarea maxlength="500" rows="4" nz-input
                                                                    placeholder="Enter the details"
                                                                    formControlName="impactAssessment"
                                                                    class="w-full"></textarea>
                                                            </nz-textarea-count>
                                                        </nz-form-control>
                                                    </nz-form-item>
                                                </nz-col>
                                            </ng-container>
                                        </nz-row>
                                    </form>
                                    }
                                </div>
                            </ng-container>
                            <ng-container *ngIf="tab.tab_type === 'history'">
                                <div class="mt-4 max-h-[300px] overflow-y-auto no-scrollbar relative">
                                    <nz-timeline>
                                        <ng-container *ngFor="let item of history;let i = index;trackBy: feUtil.trackByFn">
                                            <nz-timeline-item>
                                                <div class="flex items-center justify-between">
                                                    <div class="ml-4">
                                                        <div class="font-semibold text-gray-900 text-base mb-1"
                                                            [ngClass]="{'text-blue-700': i === 0}">
                                                            {{ item.message_type }}
                                                        </div>
                                                        <div class="text-gray-700 text-sm mb-1 whitespace-pre-line">
                                                            {{ item.message }}
                                                        </div>
                                                        <div class="flex items-center gap-2 text-xs text-gray-500">
                                                            <span>
                                                                {{ item.created_time | gDate: 'MMM d \'at\' HH.mm' }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="flex items-center gap-2">
                                                        <ng-container *ngIf="item?.remarks">
                                                            <button nz-button nzType="default" nzSize="small" role="button"
                                                                nz-popover [nzPopoverContent]="remarkTpl"
                                                                nzPopoverPlacement="bottomRight" nzPopoverTrigger="hover"
                                                                aria-label="Remark">
                                                                <i nz-icon nzType="message" nzTheme="outline"
                                                                    class="text-xs"></i> Remark
                                                            </button>
                                                            <ng-template #remarkTpl>
                                                                <div class="max-w-[300px] min-w-[220px]">
                                                                    <div
                                                                        class="flex items-center gap-2 mb-2 text-base text-primary">
                                                                        <i nz-icon nzType="message" nzTheme="outline"></i>
                                                                        <span class="font-semibold tracking-wide">Remark</span>
                                                                    </div>
                                                                    <div
                                                                        class="text-gray-700 break-words whitespace-pre-line px-2 py-0.5 rounded border border-gray-200 bg-gray-50 italic">
                                                                        {{ item?.remarks }}
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                        </ng-container>
                                                        <button
                                                            *ngIf="item?.message && (item?.message?.includes('rejected') || item?.message?.includes('Reset') || item?.message?.includes('Resubmission')) && !item?.message?.includes('Total Form Rejected') && !item?.message_type?.includes('Extension Rejected')"
                                                            nz-button nzType="default" nzSize="small"
                                                            class="border-warning/80 text-warning/80 hover:border-warning hover:text-warning focus:border-warning focus:text-warning"
                                                            aria-label="View Details"
                                                            (click)="showRejectedDetails(item, 'MODAL')">
                                                            <i nz-icon nzType="info-circle" nzTheme="outline"
                                                                aria-hidden="true"></i>
                                                            View Details
                                                        </button>
                                                    </div>
                                                </div>
                                            </nz-timeline-item>
                                        </ng-container>
                                    </nz-timeline>
                                </div>
                                <div
                                    class="w-full border bg-slate-50 rounded-lg px-2 py-2 flex gap-2 items-center justify-between absolute bottom-0 left-0 right-0">
                                    <nz-mention nzPlacement="top" [nzNotFoundContent]="'No suggestions found'"
                                        [nzSuggestions]="users">
                                        <textarea [(ngModel)]="comment" rows="1"
                                            placeholder="Write a comment... @ to mention someone" maxlength="200"
                                            nzMentionTrigger nz-input class="rounded-lg"></textarea>
                                    </nz-mention>
                                    <button nz-button nzType="primary" type="button" (click)="addComment()">
                                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                                        Comment
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </nz-tab>
                </ng-container>
            </nz-tabset>
    </ng-container>

    <ng-template #noTabs>
        <ng-container *ngIf="!feUtil.user_data.customer.compliance_level.includes(severity)">
            <div class="flex items-center justify-center w-full min-h-[410px] h-[410px] max-h-[410px]">
                <nz-empty class="text-success empty-incident text-xl" [nzNotFoundContent]="'No action required!'"
                    [nzNotFoundImage]="noIncidents"></nz-empty>
                <ng-template #noIncidents>
                    <i nz-icon nzType="hezky:Check" nzTheme="outline" class="text-7xl"></i>
                </ng-template>
            </div>
        </ng-container>
        <ng-container *ngIf="metaData.page === 'tr-incident' && feUtil.user_data.customer.compliance_level.includes(severity)  && metaData.leg_status !== 'completed'">
            <div class="flex flex-col items-center justify-center w-full min-h-[410px] h-[410px] max-h-[410px] border rounded-lg bg-gray-50 space-y-2">
                <span>
                    <i nz-icon nzType="form" nzTheme="outline" class="text-9xl text-red-400"></i>
                </span>
                <div class="text-lg text-yellow-800 font-semibold text-center">
                    Compliance Forms Disabled
                </div>
                <div class="text-base text-yellow-700 text-center">
                    Compliance forms are unavailable until the drop point is completed.
                </div>
            </div>
        </ng-container>
    </ng-template>

    <ng-template #extraContent>
        <div class="flex items-center gap-2 mb-1">
            <ng-container *ngIf="metaData.extension?.status === 'extended' && !metaData?.hide_forms">
                <button nz-button type="button" class="border border-green-200 text-green-700 cursor-default">
                    <i nz-icon nzType="check-circle" nzTheme="outline"></i>
                    <span>Due date extended</span>
                </button>
            </ng-container>

            <ng-container *ngIf="feUtil.roleService.hasAccess([0, 1, 2, 6]) && actionDetails['prod']['submitted_at']">
                <button *ngIf="!metaData?.hide_forms" nz-button nzType="default" type="button"
                    [nzLoading]="loaders['isResubmit'].loading" (click)="handleResubmit()">
                    <i nz-icon nzType="redo" nzTheme="outline" class="text-yellow-500"></i>
                    Re-Submit
                </button>
            </ng-container>
            
            <ng-container *ngIf="tabs && tabs.length > 0 && tabs[currentTab].tab_type !== 'history'
                            && actionDetails['prod']['action_by_name']
                            && actionDetails['capa']['action_by_name']
                            && actionDetails['eval']['action_by_name']
                            && (!actionDetails['final']['action_taken_at']); else finalApprovalCompleted">
                <ng-container *ngIf="feUtil.roleService.hasAccess([1, 2, 6, 7]); else pendingApproval">
                    <button *ngIf="!metaData?.hide_forms" nz-button nzType="default" type="button" nzDanger (click)="btnHandler(currentTab, -1, 'final')">Reject</button>
                    <button *ngIf="!metaData?.hide_forms" nz-button nzType="primary" type="button" nzSuccess (click)="btnHandler(currentTab, 1, 'final')">Approve</button>
                </ng-container>
                <ng-template #pendingApproval>
                    <span
                        class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-yellow-50 border border-yellow-300 text-yellow-700 font-medium text-xs">
                        <i nz-icon nzType="clock-circle" nzTheme="outline" class="text-yellow-500"></i>
                        Pending final approval
                    </span>
                </ng-template>
            </ng-container>
        
            <ng-template #finalApprovalCompleted>
                @if(actionDetails['final']['action_taken_at'] &&
                tabs[currentTab].tab_type !== 'history') {
                <button nz-button nzType="default" type="button" role="button" (click)="viewReport()">
                    <i nz-icon nzType="file-search" nzTheme="outline" class="text-blue-600"></i>
                    <span>View Report</span>
                </button>
                <button nz-button nzType="default" nz-popover [nzPopoverTitle]="'Final Approval Details'"
                    [nzPopoverContent]="approvalPopover" [nzPopoverPlacement]="'bottomRight'" [nzPopoverTrigger]="'hover'">
                    <i nz-icon nzType="check-circle" nzTheme="twotone" class="text-green-500"></i>
                    <span>Completed</span>
                </button>
                <ng-template #approvalPopover>
                    <div class="flex flex-col gap-2 text-xs">
                        <div class="flex items-center gap-1">
                            <i nz-icon nzType="user" nzTheme="outline" class="text-blue-500"></i>
                            <span class="font-medium text-gray-600">By:</span>
                            <span class="text-gray-900">{{ actionDetails['final']['action_by_name'] || 'N/A' }}</span>
                        </div>
                        <div class="flex items-center gap-1">
                            <i nz-icon nzType="clock-circle" nzTheme="outline" class="text-green-500"></i>
                            <span class="font-medium text-gray-600">At:</span>
                            <span class="text-gray-900">
                                {{ (actionDetails['final']['action_taken_at'] | gDate: 'dd/MM/yyyy HH:mm:ss') || 'N/A' }}
                            </span>
                        </div>
                    </div>
                </ng-template>
                }
            </ng-template>

            <ng-container *ngIf="!metaData.is_assigned_to_user && metaData?.hide_forms && metaData.extension?.status !== 'pending'">
                <span
                    class="inline-flex items-center gap-x-2 px-3 py-1.5 rounded-lg border border-danger/80 text-danger/80 text-xs shadow-sm">
                    <i nz-icon nzType="warning" nzTheme="outline" class="text-xs text-danger/80"></i>
                    <span>Due date exceeded</span>
                </span>
            </ng-container>
        
            <ng-container *ngIf="feUtil.roleService.hasAccess([0, 1, 2, 5, 6, 7]) && metaData?.hide_forms && (metaData.extension?.status === 'to-be-expired' || metaData.extension?.status === 'extended')">
                <button type="button" nz-button nzType="default" type="button" (click)="extensionModalHandler('request');">
                    <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                    Request Extension
                </button>
            </ng-container>

            <ng-container *ngIf="metaData.extension?.status === 'pending' && metaData.is_assigned_to_user">
                <span class="inline-flex items-center gap-x-2 px-4 py-2 rounded-lg border border-warning/80 text-warning/80 font-semibold text-xs shadow-sm">
                    <i nz-icon nzType="info-circle" nzTheme="outline" class="text-xs text-warning/80"></i>
                    <span>Awaiting extension approval</span>
                </span>
            </ng-container>

            <ng-container
                *ngIf="metaData.hide_forms && metaData.extension?.status === 'pending' && this.feUtil.roleService.hasAccess([0, 1, 2, 6])">
                <button nz-button type="button" nzType="default" nzDanger nz-popover [nzPopoverContent]="dueDatePassedContent"
                    [nzPopoverPlacement]="'bottomRight'">
                    <i nz-icon nzType="warning"></i>
                    Form due date exceeded
                </button>
                <ng-template #dueDatePassedContent>
                    <div class="flex flex-col gap-2 text-xs rounded-md bg-red-50 p-3 min-w-[210px]">
                        <button nz-button nzType="default" type="button" (click)="extensionModalHandler('approved')">
                            <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                            Extend Due Date
                        </button>
                        <button nz-button nzType="default" type="button" (click)="extensionModalHandler('rejected')">
                            <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                            Reject Extension Request
                        </button>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </ng-template>

    <ng-container *ngIf="tabs && tabs.length > 0 && tabs[currentTab].tab_type !== 'history'">
        <div class="w-full flex gap-2 items-center justify-between mt-6 border-t pt-3">
            <div class="flex flex-col sm:flex-row items-center gap-2 w-full text-xs">
                @let submittedAt = actionDetails[tabs[currentTab].form_type]['submitted_at'];
                @let submittedByName = actionDetails[tabs[currentTab].form_type]['submitted_by_name'];
                @let approvedAt = actionDetails[tabs[currentTab].form_type]['action_taken_at'];
                @let approvedByName = actionDetails[tabs[currentTab].form_type]['action_by_name'];
                @if(submittedAt && !approvedAt) {
                <span class="text-xs font-medium mr-1">Status:</span>
                <button nz-button nzType="default" nzSize="small" class="flex items-center gap-1 px-4 py-1 border border-warning/80 text-warning/80 hover:border-warning/80 hover:text-warning/80 focus:border-warning/80 focus:text-warning/80 backdrop:shadow-sm cursor-pointer"
                    nz-popover [nzPopoverTitle]="''" [nzPopoverContent]="inciPopoverContent" [nzPopoverPlacement]="'topRight'" [nzPopoverTrigger]="'hover'">
                    <i nz-icon nzType="clock-circle" nzTheme="outline" class="text-warning/80 text-sm"></i>
                    <span class="font-medium"> Awaiting Approval </span>
                </button>
                }
                @if(approvedAt) {
                <span class="text-xs font-medium mr-1">Status:</span>
                <button nz-button nzType="default" nzSize="small" class="flex items-center gap-1 px-2 py-1 border border-green-500 text-green-600 hover:border-green-500 hover:text-green-600 focus:border-green-500 focus:text-green-600 shadow-sm cursor-pointer"
                    nz-popover [nzPopoverTitle]="''" [nzPopoverContent]="inciPopoverContent" [nzPopoverPlacement]="'topRight'" [nzPopoverTrigger]="'hover'">
                    <i nz-icon nzType="check-circle" nzTheme="outline" class="text-green-600 text-sm"></i>
                    <span class="font-medium"> Approved </span>
                </button>
                }
                <ng-template #inciPopoverContent>
                    <div class="flex space-x-4">
                        <div class="flex flex-col gap-2 text-xs border p-1 rounded-lg">
                            <div class="gap-1 border-b pb-1">
                                <span>Submitted by</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i nz-icon nzType="user" nzTheme="outline" class="text-blue-500"></i>
                                <span class="text-gray-900">{{ submittedByName || 'N/A'}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i nz-icon nzType="clock-circle" nzTheme="outline" class="text-green-500"></i>
                                <span class="text-gray-900"> {{ (submittedAt | gDate: 'dd/MM/yyyy HH:mm:ss') ||
                                    'N/A' }}
                                </span>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2 text-xs border p-1 rounded-lg" *ngIf="approvedAt">
                            <div class="border-b pb-1">
                                <span>Approved by</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i nz-icon nzType="user" nzTheme="outline" class="text-blue-500"></i>
                                <span class="text-gray-900">{{ approvedByName ||
                                    'N/A'}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i nz-icon nzType="clock-circle" nzTheme="outline" class="text-green-500"></i>
                                <span class="text-gray-900">
                                    {{ (approvedAt | gDate: 'dd/MM/yyyy HH:mm:ss') || 'N/A' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="flex items-center gap-2">
                <button nz-button nzType="default" type="button" nzDanger (click)="btnHandler(currentTab, -1)"
                    [disabled]="!tabs[currentTab].canReject" [nzLoading]="loaders[tabs[currentTab].form_type].reject"
                    *ngIf="actionDetails[tabs[currentTab].form_type]['submitted_by_name'] && (!actionDetails[tabs[currentTab].form_type]['action_by_name'] || actionDetails[tabs[currentTab].form_type]['action_by_name'] == ' ')">
                    <i nz-icon nzType="close-circle" nzTheme="outline"></i>
                    Reject
                </button>
                <button nz-button nzType="default" type="button"
                    class="text-success border-success focus:border-success focus:text-success hover:border-success hover:text-success"
                    (click)="btnHandler(currentTab, 1)" [disabled]="!tabs[currentTab].canApprove"
                    [nzLoading]="loaders[tabs[currentTab].form_type].approve"
                    *ngIf="actionDetails[tabs[currentTab].form_type]['submitted_by_name'] && (!actionDetails[tabs[currentTab].form_type]['action_by_name'] || actionDetails[tabs[currentTab].form_type]['action_by_name'] == ' ')">
                    <i nz-icon nzType="check-circle" nzTheme="outline" class="text-success"></i>
                    Approve
                </button>
                <button nz-button nzType="primary" type="button" (click)="btnHandler(currentTab, 0)"
                    [nzLoading]="loaders[tabs[currentTab].form_type].submit" [disabled]="!tabs[currentTab].canSubmit"
                    *ngIf="!actionDetails[tabs[currentTab].form_type]['submitted_by_name']">
                    <i nz-icon nzType="send" nzTheme="outline"></i>
                    Submit
                </button>
            </div>
        </div>
    </ng-container>
</nz-card>

<nz-modal [(nzVisible)]="modals['isProductModal']" [nzTitle]="'Affected Products'" (nzOnCancel)="handleProductModalCancel()"
    nzWidth="800px" nzCloseOnNavigation [nzMaskClosable]="false">
    <ng-container *nzModalContent>
        <ng-container *ngIf="!showProductTable && products.length === 0 && currentTab === 0">
            <div class="text-center">
                <button nz-button nzType="primary" class="mb-4" type="button"
                    (click)="showProductTable = true; addProduct()">
                    Add Affected Products Manually
                </button>
                <div class="my-4">OR</div>
                <div
                    class="upload-container border border-dashed border-[#0B71B4] rounded-lg p-6 bg-[#F4FAFF] flex flex-col items-center">
                    <label for="excelFile" class="flex flex-col items-center cursor-pointer w-full">
                        <i nz-icon nzType="upload" nzTheme="outline"
                            class="text-[#0B71B4] text-2xl mb-3 transition-transform group-hover:scale-110"></i>
                        <span class="inline-block bg-[#0B71B4] text-white rounded px-3 py-1 mb-2 text-xs font-medium">Upload Excel File</span>
                        <input type="file" id="excelFile" (change)="onProductFileChange($event)" accept=".xls,.xlsx" style="display: none;">
                        <span class="ant-upload-text text-gray-800 font-semibold block mb-1">Click or drag file to this area to upload</span>
                        <span class="ant-upload-hint text-gray-500 text-xs block text-center mb-1">
                            Ensure file headers match expected columns and all fields are appropriately filled in.
                        </span>
                    </label>
                </div>
                <div class="my-4">
                    <a class="cursor-pointer hover:underline" nz-popconfirm
                        nzPopconfirmTitle="Are you sure to download this template file?" nzPopconfirmPlacement="bottom" (nzOnConfirm)="downloadTemplate()">
                        <span>
                            <i nz-icon nzType="download" nzTheme="outline"></i>
                            Download template .xlsx file
                        </span>
                    </a>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="showProductTable || products.length > 0 && currentTab === 0">
            <form nz-form nzLayout="vertical" [formGroup]="affectedProductForm">
                <div class="flex items-center justify-between mb-2">
                    <span class="text-primary text-xs" *ngIf="!actionDetails['prod']['submitted_at']">
                        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                        To add a new row press enter at the last field of the last row
                    </span>
                    <button nz-button nzType="primary" type="button" class="mr-2 border-0" (click)="addProduct()"
                        *ngIf="!products.disabled">
                        <i nz-icon nzType="plus" nzTheme="outline"></i> Add Product
                    </button>
                </div>
                <nz-table [nzData]="products.value || []" [nzSize]="'small'" [nzFrontPagination]="false"
                    nzShowPagination="false" nzSize="small" [nzScroll]="{ y: '360px'  }" nzTableLayout="fixed">
                    <thead>
                        <tr>
                            <th nzWidth="60px">Sr.No.</th>
                            <th nzEllipsis>Product Name <span class="text-red-500">*</span></th>
                            <th nzEllipsis>Batch No. <span class="text-red-500">*</span></th>
                            <th nzEllipsis>No. Of Units Affected <span class="text-red-500">*</span></th>
                            <th nzWidth="80px" nzEllipsis *ngIf="!actionDetails['prod']['submitted_at']">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container formArrayName="products">
                            <ng-container *ngIf="products.controls.length > 0">
                                <tr *ngFor="let product of products.controls || []; let i = index" [formGroupName]="i">
                                    <td nzWidth="50px">
                                        <nz-space nzSize="small">
                                            {{ i + 1 }}
                                        </nz-space>
                                    </td>
                                    <td>
                                        <nz-form-item class="mb-0">
                                            <nz-form-control>
                                                <nz-select [nzPlaceHolder]="'Select affected product'"
                                                    formControlName="product_name" class="w-full" nzShowSearch>
                                                    <nz-option *ngFor="let masterProduct of masterProductList"
                                                        [nzValue]="masterProduct.product_id"
                                                        [nzLabel]="masterProduct.generic_name"></nz-option>
                                                </nz-select>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </td>
                                    <td>
                                        <nz-form-item class="mb-0">
                                            <nz-form-control>
                                                <input nz-input formControlName="batch_no" placeholder="Enter batch number" />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </td>
                                    <td>
                                        <nz-form-item class="mb-0">
                                            <nz-form-control>
                                                <input nz-input type="number" formControlName="units_affected"
                                                    (keydown.enter)="addProduct()" OnlyNumber
                                                    placeholder="Enter number of units" />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </td>
                                    <td *ngIf="!actionDetails['prod']['submitted_at']">
                                        <nz-space nzSize="small">
                                            <button nz-button nzType="text" type="button" nzShape="circle" nzDanger
                                                (click)="removeProduct(i)" [disabled]="products.disabled">
                                                <i nz-icon nzType="delete" nzTheme="outline"></i>
                                            </button>
                                        </nz-space>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </nz-table>
            </form>
        </ng-container>

        <ng-container *ngIf="products.length > 0 && currentTab === 2">
            <nz-table [nzData]="products.value || []" [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ y: '300px' }">
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th>Batch No</th>
                        <th>Units Affected</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of products.value || []">
                        <td>{{ getProductName(item?.prod_id) }}</td>
                        <td>{{ item?.batch_no }}</td>
                        <td>{{ item?.units_affected }}</td>
                        <td>
                            <ng-container *ngIf="!actionDetails['eval']['submitted_at'] else showResult">
                                <nz-radio-group [(ngModel)]="item.is_selected" nzButtonStyle="solid"
                                    [nzDisabled]="actionDetails['eval']['submitted_by_name'] || metaData.hide_forms || !feUtil.roleService.hasAccess([0, 1, 2, 6])">
                                    <label nz-radio-button [nzValue]="1" [ngClass]="item.is_selected == 1 ? 'radio-button-success' : ''">
                                        <i nz-icon nzType="check" nzTheme="outline"></i>
                                    </label>
                                    <label nz-radio-button [nzValue]="-1" [ngClass]="item.is_selected == -1 ? 'radio-button-danger' : ''">
                                        <i nz-icon nzType="close" nzTheme="outline"></i>
                                    </label>
                                </nz-radio-group>
                            </ng-container>
                            <ng-template #showResult>
                                <ng-container [ngSwitch]="item.is_selected">
                                    <span *ngSwitchCase="1" class="text-success text-xs">Released</span>
                                    <span *ngSwitchCase="-1" class="text-danger text-xs">Rejected</span>
                                    <span *ngSwitchCase="0" class="text-gray-500 text-xs">N/A</span>
                                </ng-container>
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
            </nz-table>
            <div class="flex justify-start gap-x-2 mt-2" *ngIf="feUtil.roleService.hasAccess([0, 1, 2, 6]) && !actionDetails['eval']['submitted_at']">
                <button [disabled]="actionDetails['eval']['submitted_at'] || metaData.hide_forms" nz-button nzType="default" class="text-success border-success focus:border-success focus:text-success hover:border-success hover:text-success" type="button" (click)="rejectOrReleaseHandler(1)">Release ALL</button>
                <button [disabled]="actionDetails['eval']['submitted_at'] || metaData.hide_forms" nz-button nzType="default" nzDanger type="button" (click)="rejectOrReleaseHandler(-1)">Reject ALL</button>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *nzModalFooter>
        <div class="flex justify-between" *ngIf="showProductTable || products.length">
            <button *ngIf="!products.length else showWithPopConfirm" nz-button nzType="default" type="button"
                (click)="backToExcel()">
                Back
            </button>
            <ng-template #showWithPopConfirm>
                <button
                    *ngIf="(currentTab == 0 && !actionDetails['prod']['submitted_at']); else blankDiv"
                    nz-button nzType="default" type="button" nz-popconfirm nzPopconfirmPlacement="top"
                    nzPopconfirmTitle="Go back action will remove all filed products?" (nzOnConfirm)="backToExcel()">
                    Back
                </button>
            </ng-template>
            <div class="flex items-center gap-x-2">
                <button nz-button nzType="default" type="button" (nzOnConfirm)="products.clear(); showProductTable = true; addProduct()" nz-popconfirm
                    nzPopconfirmPlacement="top" nzPopconfirmTitle="Reset all products?"
                    *ngIf="(currentTab == 0 && !actionDetails['prod']['submitted_at'] && products.length > 0) else blankDiv">
                    Reset
                </button>
                <button
                    *ngIf="(currentTab == 0 && !actionDetails['prod']['submitted_at']) || (currentTab == 2 && !actionDetails['eval']['submitted_at'])"
                    nz-button nzType="primary" type="button" (click)="saveProducts()"
                    [disabled]="metaData.hide_forms || !tabs.length || !tabs[currentTab].canProduct || hasDuplicateExists">
                    Submit
                </button>
            </div>
            <ng-template #blankDiv>
                <div>&nbsp;</div>
            </ng-template>
        </div>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modals['isCapaModalVisible']" [nzTitle]="''" nzWidth="600px" nzCentered nzCloseOnNavigation
    [nzMaskClosable]="false" [nzClosable]="false" [nzCancelText]="null" (nzOnOk)="capaModalHandler()"
    [nzBodyStyle]="{ 'max-height': '500px', 'overflow-y': 'auto' }">
    <ng-container *nzModalContent>
        <div class="bg-blue-50 rounded-lg p-5 border border-blue-100 mb-4 flex items-center gap-3">
            <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                <i nz-icon nzType="file-protect" nzTheme="outline" class="text-white text-xl"></i>
            </div>
            <div class="flex flex-col">
                <span class="font-semibold text-base text-gray-800">Upload CAPA Supporting Files</span>
                <span class="text-xs text-gray-600 flex items-center gap-1">
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    File size should be <span class="font-semibold text-gray-700">10MB</span> or less. Accepted: PDF, Images, Excel, CSV.
                </span>
            </div>
        </div>
        <div class="upload-container mt-1">
            <nz-upload
                nzType="drag"
                [nzMultiple]="true"
                [(nzFileList)]="capaFiles"
                [nzBeforeUpload]="beforeUploadCapaFile"
                [nzShowUploadList]="true"
                [nzAccept]="['.pdf', '.jpeg', '.jpg', '.png', '.csv', '.xlsx', '.xls']">
                <div class="text-center py-5">
                    <i nz-icon nzType="cloud-upload" nzTheme="outline" class="text-5xl text-blue-400 mb-2"></i>
                    <div class="font-medium text-gray-800 mb-1">Click or drag file(s) to this area to upload</div>
                    <p class="text-xs text-gray-500">PDF, JPG, PNG, XLSX, XLS, CSV, XLSX, XLS are supported</p>
                </div>
            </nz-upload>

            <ng-container *ngIf="rejectedCapaFiles.length > 0">
                <div class="mt-4 border border-warning-100 rounded-lg p-2">
                    <nz-alert nzType="warning" nzMessage="Previously Uploaded Files"
                        nzDescription="This file will not be attached to the current CAPA submission." nzShowIcon class="mb-2" nzBanner>
                    </nz-alert>
                    <ul class="divide-y divide-gray-100">
                        <li *ngFor="let file of rejectedCapaFiles" class="flex items-center py-2">
                            <i nz-icon nzType="file-text" nzTheme="outline" class="mr-2 text-lg text-blue-400"></i>
                            <span class="flex-1 truncate" [title]="file.doc_name">{{ file.doc_name }}</span>
                            <button nz-button nzType="link" (click)="feUtil.downloadS3File(file)" *ngIf="file.doc_link">
                                <i nz-icon nzType="download" nzTheme="outline"></i>
                                Download
                            </button>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modals['isRequestExtensionModalVisible']"
    [nzTitle]="''"
    (nzOnCancel)="modals['isRequestExtensionModalVisible'] = false; extensionForm.reset();" nzWidth="500px" nzCentered nzCloseOnNavigation nzOkText="Submit" [nzMaskClosable]="false" [nzClosable]="false"
    (nzOnOk)="requestExtensionHandler()" [nzOkLoading]="loaders['extension'].submit">
    <ng-container *nzModalContent>
        <div class="flex flex-col gap-2">
            <form nz-form nzLayout="vertical" [formGroup]="extensionForm">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="adminError">
                        <nz-form-label nzRequired>{{ (flag == 'approved' ? 'Approving' : flag == 'rejected' ? 'Rejecting': 'Requesting') + ' personnel'}}</nz-form-label>
                        <nz-select nzPlaceHolder="Select Quality Personnel" [nzShowSearch]="true" class="w-full"
                            formControlName="admin_id">
                            <nz-option *ngFor="let user of qualityPersonnelList" [nzValue]="user.user_id"
                                [nzLabel]="user.username"></nz-option>
                        </nz-select>
                    </nz-form-control>
                    <ng-template #adminError let-control>
                        @if(control.hasError('required')){
                        Remarks is required!
                        }
                    </ng-template>
                </nz-form-item>
                <ng-container *ngIf="flag === 'approved'">
                    <nz-form-item>
                        <nz-form-control>
                            <nz-form-label nzRequired>Select Number of Days</nz-form-label>
                            <nz-input-group nzCompact>
                                <nz-input-number [nzMin]="0" OnlyNumber nzPlaceHolder="Enter number of days" [nzMax]="60" [nzStep]="1"
                                    formControlName="unit" style="width:50%">
                                </nz-input-number>
                                <nz-select formControlName="type" nzPlaceHolder="Select interval" style="width:50%;">
                                    <nz-option *ngIf="!feUtil.isProduction" [nzValue]="'minute'" [nzLabel]="'Minutes'"></nz-option>
                                    <nz-option [nzValue]="'days'" [nzLabel]="'Days'"></nz-option>
                                </nz-select>
                            </nz-input-group>
                            <div class="flex items-center justify-between gap-2">
                                <ng-container *ngIf="extensionForm.get('unit')?.invalid && (extensionForm.get('unit')?.dirty || extensionForm.get('unit')?.touched)">
                                    <div class="ant-form-item-explain-error">
                                        <span *ngIf="extensionForm.get('unit')?.hasError('required')">
                                            Number of days is required!
                                        </span>
                                        <span *ngIf="extensionForm.get('unit')?.hasError('min') || extensionForm.get('unit')?.hasError('max')">
                                            Number of days must be between 1 and 60!
                                        </span>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="extensionForm.get('type')?.invalid && (extensionForm.get('type')?.dirty || extensionForm.get('type')?.touched)">
                                    <div class="ant-form-item-explain-error">
                                        <span *ngIf="extensionForm.get('type')?.hasError('required')">
                                            Type is required!
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                </ng-container>
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="remarksError">
                        <nz-form-label nzRequired>Remarks</nz-form-label>
                        <nz-textarea-count [nzMaxCharacterCount]="300">
                            <textarea nz-input formControlName="remarks" placeholder="Enter remarks" maxlength="300"
                                rows="3"></textarea>
                        </nz-textarea-count>
                    </nz-form-control>
                    <ng-template #remarksError let-control>
                        @if(control.hasError('required')){
                        Remarks is required!
                        }
                        @if(control.hasError('minlength')){
                        Remarks must be at least 3 characters long!
                        }
                    </ng-template>
                </nz-form-item>
            </form>
        </div>
    </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modals['isFormReportModal']" [nzTitle]="isViewReport ? 'Form report' : 'Last filled form data'"
    (nzOnCancel)="modals['isFormReportModal'] = false; isViewReport = false;" 
    (nzOnOk)="modals['isFormReportModal'] = false; isViewReport = false;"  nzWidth="950px" nzCentered nzCloseOnNavigation
    [nzMaskClosable]="false" [nzClosable]="true" [nzFooter]="isViewReport ? showDownloadButton : null"
    [nzBodyStyle]="{ 'padding': '12px 24px', 'max-height': '600px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }">
    <ng-container *nzModalContent>
        <div>
            <app-incident-form-report [formReportData]="isViewReport ? reportFormData : rejectedFormData"></app-incident-form-report>
            <ng-container *ngIf="isViewReport">
                <div class="mt-4" #graphTemplate>
                    <ng-container *ngIf="metaData.page === 'tr-incident'">
                        <app-tr-graph [alarmData]="[]"
                            [metaData]="{ page: 'tr-incident', id: metaData.id, trip_status: 'completed', date: metaData.date }"
                            [capabilities]="metaData.capabilities"
                            [viewOptions]="{ view: ['graph'], radio: { show: false, disable: true }, dateRange: { show: false, disable: true }, allowZoom: false, showTitle: false, showDownloadButton: false }" />
                    </ng-container>
                    <ng-container *ngIf="metaData.page === 'storage-incident'">
                        <app-storage-graph [alarmData]="[]"
                            [metaData]="{ id: metaData.id, page: 'storage-incident', date: metaData.date}"
                            [capabilities]="metaData.capabilities" [isActive]="true" [decommissionDate]="''"
                            [viewOptions]="{ view: ['graph'], radio: { show: false, disable: true }, dateRange: { show: false, disable: true }, allowZoom: false, showTitle: false, showDownloadButton: false }" />
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>Total {{ total }} items</ng-template>

<ng-template #errorMessageTemplate let-control>
    @if(control.errors?.['required']) { <span>This field is required</span>}
    @if(control.errors?.['minlength']) { <span>This field must be at least {{ control.errors?.['minlength'].requiredLength }} characters long</span>}
</ng-template>

<ng-template #showLoader>
    <nz-card class="min-h-[410px] h-[410px] max-h-[410px] flex flex-col items-center justify-center">
        <div class="flex flex-col items-center justify-center">
            <nz-spin></nz-spin>
            <span class="mt-4 text-primary">Loading form data...</span>
        </div>
    </nz-card>
</ng-template>

<ng-template #showDownloadButton>
    <button
        *ngIf="isViewReport && reportFormData?.prod?.excursionDetails && reportFormData?.capa?.capaDetails && reportFormData?.eval?.evalDispDetails"
        nz-button nzType="primary" (click)="downloadReport()" [nzLoading]="loaders['isDownloading'].loading">
        <i nz-icon nzType="download" nzTheme="outline"></i>
        Download Report
    </button>
</ng-template>